import React from 'react'
import '../styles/shared/common.scss'

function resolveHighlights (text: string): React.ReactNode {
  const parts = text.split(/{highlight}(.*?){\/highlight}/)
  if (parts.length === 1) return text
  return parts.map((part, i) =>
    i % 2 === 1 ? <span key={i} className="highlight">{part}</span> : part
  )
}

/**
 * Resolves `{highlight}` tokens into `<span class="highlight">`. Accepts a
 * plain string or a pre-resolved `ReactNode` (e.g. markup with `mp-mask`
 * spans from first-name masking), in which case highlights are resolved
 * within the string segments only and existing elements pass through untouched.
 */
export function useHighlightedText (node: React.ReactNode): React.ReactNode {
  if (typeof node === 'string') return resolveHighlights(node)
  if (Array.isArray(node)) {
    return node.map((child, i) =>
      typeof child === 'string'
        ? <React.Fragment key={`highlight-${i}`}>{resolveHighlights(child)}</React.Fragment>
        : child
    )
  }
  return node
}
